import React from "react";

import { Box, Grid, Skeleton } from "@mui/material";

function VideoSkeleton() {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            aspectRatio: "16/9",
            width: "100%",
            height: "auto",
            transform: "none",
          }}
        />
        <Box sx={{ p: 2 }}>
          <Skeleton variant="text" width="78%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="50%" height={16} />
        </Box>
      </Box>
    </Grid>
  );
}

function LoadingSkeletons() {
  return (
    <>
      {Array.from({ length: 8 }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <VideoSkeleton key={i} />
      ))}
    </>
  );
}

export { VideoSkeleton, LoadingSkeletons };
